import CheckoutComponent from "./CheckoutComponent";

export default class CheckoutPaySystem {
    private BX: any;

    constructor(BX: any) {
        this.BX = BX;
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        let self = this;
        $(document).on('click', '.checkout-paysystem', function(e){
            self.setPaySystem(e);
        });
    }

    setPaySystem(e: JQuery.ClickEvent<Document, undefined, any, any>)
    {
        let $target = $(e.target).closest('.paysystem-item');
        let basketGroupId = $(e.target).closest('.basket-group').data('group');
        $target.addClass('checked');
        CheckoutComponent.arResult.BASKET.GROUPS[basketGroupId].SELECTED_PAY_SYSTEM = {
            ID: $target.data('id'),
            CODE: $target.data('code'),
        };
    }
}